import { handleGetRequest, handlePatchRequest } from "./http.service";
import { Settings } from "types/settings.type";
import { IFile } from "types/file.type";

export const getSettings = async () => {
  return await handleGetRequest<Settings>("/settings");
};

export const setLogo = async (file: IFile) => {
  return await handlePatchRequest<{ logo: IFile }, null>(`/settings/logo`, {
    logo: file,
  });
};
